import { render, staticRenderFns } from "./InputLightSearch.vue?vue&type=template&id=8727b734"
import script from "./InputLightSearch.vue?vue&type=script&lang=js"
export * from "./InputLightSearch.vue?vue&type=script&lang=js"
import style0 from "./InputLightSearch.vue?vue&type=style&index=0&id=8727b734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports